var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 12H3.33333C2.59695 12 2 11.4573 2 10.7879V6.54545C2 5.87602 2.59695 5.33333 3.33333 5.33333H12.6667C13.403 5.33333 14 5.87602 14 6.54545V10.7879C14 11.4573 13.403 12 12.6667 12H11M4.66667 2H11.3333V5.33333H4.66667V2ZM4.66667 10H11.3333V14H4.66667V10Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.36d7f38f7fad02c2ec937fdc8b9ce00b.svg";
export { ForwardRef as ReactComponent };